'use client'

import { OPEN_BANNER_EVENT } from '@/lib/consent'

/** Botão (rodapé e página de privacidade) que reabre o aviso para o visitante mudar a escolha. */
export default function CookiePreferences({ label, className = '' }: { label: string; className?: string }) {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(OPEN_BANNER_EVENT))}
      className={`underline underline-offset-4 hover:text-accent-green focus-visible:ring-2 focus-visible:ring-[#718d00] ${className}`}
    >
      {label}
    </button>
  )
}
